module.exports = __webpack_public_path__ + "img/P150T_weapon_46.cb705016.png";